import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><g fillRule="evenodd"><path fillRule="nonzero" d="M21 12a9 9 0 10-18 0 9 9 0 0018 0zM2 12a10 10 0 1120 0 10 10 0 01-20 0z" /><path d="M13 11v3l4-3.5L13 7v3c-3.32.04-6 2.7-6 6h1a5.03 5.03 0 015-5z" /></g></svg>);